export const APARTMENT = 'apartment';
export const HOUSE = 'house';
export const STEAD = 'stead';
export const COMMERCIAL = 'commercial';
export default [APARTMENT, HOUSE, STEAD, COMMERCIAL];
